/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressApiModel } from './addressApiModel';


export interface WorkplaceApiModel { 
    id: number;
    name: string;
    code: string;
    employerId: number;
    addressDto: AddressApiModel;
}

